import React, { useContext, useState } from "react";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Tooltip,
  Typography,
  Link,
} from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";
import { PageContext } from "../../../context/PageContext";
// import Link from "next/link";
const ScenarioFourContent: React.FC = () => {
  const content = useContext(PageContext);
  return (
    <>
      <Typography sx={{ fontSize: "1.25rem" }}>
        {content.proposedStrategyTitle}
      </Typography>
      <br />
      <Typography sx={{ fontSize: "1rem" }}>
        {content.proposedStrategyDesc1}
      </Typography>
      <br></br>
      <Typography sx={{ fontSize: "1rem", fontWeight: "semibold" }}>
        {content.proposedStrategyDesc2}{" "}
        <Link href={"https://dme.dc.gov/boundaries2023"}>
          {content.proposedStrategyDesc2Link1}
        </Link>
        {"."}
      </Typography>
    </>
  );
};

export const ScenarioExplanationsModal: React.FC = () => {
  const [open, setOpen] = useState<boolean>(false);
  const content = useContext(PageContext);

  return (
    <>
      <Tooltip title={content.tempLearnMore} enterTouchDelay={0}>
        <IconButton onClick={() => setOpen(true)} sx={{ p: 0 }}>
          <HelpIcon />
        </IconButton>
      </Tooltip>
      <Modal open={open} onClose={() => setOpen(false)}>
        <Box sx={modalStyle}>
          <ScenarioFourContent />
          <Button variant="outlined" onClick={() => setOpen(false)}>
            Okay
          </Button>
        </Box>
      </Modal>
    </>
  );
};
const modalStyle = {
  position: "absolute",
  top: "50%",
  gap: 0.5,
  backgroundColor: "#FFF",
  display: "flex",
  borderRadius: 2,
  flexDirection: "column",
  maxHeight: "80vh",
  overflow: "auto",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "85%", md: 600 },
  boxShadow: 24,
  p: 4,
};
